export default {
  generic: "Something went wrong. Please try again.",
  serverError: "A server error occurred. Please try again.",
  network: "Network error. Check your connection and try again.",
  validation: "Please check the submitted values and try again.",
  loginFailed: "Login failed",
  createActivity: "Error creating activity",
  updateActivity: "Error updating activity",
  activityActivationIncomplete:
    "Cannot activate this activity yet. Still missing: {{items}}.",
  activityActivationMissingDescription: "description in every language",
  activityActivationMissingPhotos: "at least one photo",
  activityActivationMissingMenuItems: "menu items",
  activityActivationMissingPricedItems: "at least one item with a price greater than zero",
  activityActivationMissingAvailability: "at least one availability slot",
  updateServiceCategories: "Error updating service categories",
  changeProfileType: "Failed to change profile type",
  saveProfile: "Error saving profile",
  loadDevicePresets: "Failed to load device presets",
  savePreset: "Failed to save preset",
  deletePreset: "Failed to delete preset",
  createDevice: "Failed to create device",
  deviceDuplicateSerialNumber:
    "There is already a device with that serial number",
  deviceDuplicateSoftwareId:
    "The software key is already assigned to device with serial {{serialNumber}}",
  deviceDuplicateSoftwareIdUnknown:
    "The software key is already assigned to another device",
  loadDevices: "Failed to load devices",
  loadReaders: "Failed to load readers",
  loadReaderPresets: "Failed to load reader presets",
  updateDevice: "Failed to update device",
  regenerateCredentials: "Failed to regenerate credentials",
  assignDevice: "Failed to assign device",
  updateHouse: "Failed to update structure",
  renameDevice: "Failed to rename device",
  reorderDevices: "Failed to reorder devices",
  loadHouses: "Failed to load structures",
  loadHosts: "Failed to load hosts",
  loadSalesAgents: "Failed to load sales agents",
  loadOwners: "Failed to load sellers and hosts",
  loadSellers: "Failed to load sellers",
  loadActivities: "Failed to load activities",
  loadRegions: "Failed to load regions",
  createHouse: "Failed to create structure",
  createHost: "Failed to create host",
  readerOperation: "Reader operation failed",
  addPresence: "Failed to register guest",
  updatePresence: "Failed to update guest",
  deletePresence: "Failed to remove guest",
  createSalesAgent: "Failed to create sales agent",
  autoTranslateItem: "Auto-translate failed. Try again later.",
  forgotPasswordFailed: "Could not send reset email. Try again later.",
  setPasswordFailed: "Could not set password. Try again or request a new link.",
  amendReasonWrongStatus:
    "This booking cannot be amended in its current status.",
  amendReasonRefunded: "This booking was refunded and cannot be amended.",
  amendReasonRefundRetrying: "A refund is in progress; try again later.",
  amendReasonProviderBlocksAmendment:
    "This booking is synced with a reservation provider and cannot be amended here.",
  amendReasonMissingVisit: "This booking has no visit date/time to amend.",
  amendRequiresOverride:
    "Capacity or booking-deadline constraints require an explicit override.",
  impersonateUser: "Could not impersonate this user.",
} as const;
